<template>
  <div>
    <h1 class="Timetitle">第二十一届中国(上海)国际乐器展览会展会时间表</h1>
    <div>
      <h3 class="Tabletitle">布展时间</h3>
      <table class="Timetable" cellspacing="1" cellpadding="1">
        <tr>
          <td width="20%"></td>
          <td width="40%">10月08日 周二</td>
          <td width="40%">10月09日 周三</td>
        </tr>
        <tr>
          <td width="20%">光地</td>
          <td width="40%">8：30－22：00</td>
          <td width="40%">8：30－22：00</td>
        </tr>
        <tr>
          <td width="20%">标准展位</td>
          <td width="40%">13：30－22：00</td>
          <td width="40%">8：30－22：00</td>
        </tr>
      </table>
      <h3 class="Tabletitle">展商工作时间</h3>
      <table class="Timetable" cellspacing="1" cellpadding="1">
        <tr>
          <td width="25%">10月10日 周四</td>
          <td width="25%">10月11日 周五</td>
          <td width="25%">10月12日 周六</td>
          <td width="25%">10月13日 周日</td>
        </tr>
        <tr>
          <td width="25%">8：30－17：30</td>
          <td width="25%">8：30－17：30</td>
          <td width="25%">8：30－17：30</td>
          <td width="25%">8：30－16：00</td>
        </tr>
      </table>
      <h3 class="Tabletitle">观众参观时间</h3>
      <table class="Timetable" cellspacing="1" cellpadding="1">
        <tr>
          <td width="25%">10月10日 周四</td>
          <td width="25%">10月11日 周五</td>
          <td width="25%">10月12日 周六</td>
          <td width="25%">10月13日 周日</td>
        </tr>
        <tr>
          <td width="25%">9：30－17：00</td>
          <td width="25%">9：30－17：00</td>
          <td width="25%">9：30－17：00</td>
          <td width="25%">9：30－15：30</td>
        </tr>
      </table>
      <h3 class="Tabletitle">撤展时间</h3>
      <table class="Timetable" cellspacing="1" cellpadding="1">
        <tr>
          <td width="40%"></td>
          <td width="60%">10月13日 周日</td>
        </tr>
        <tr>
          <td width="40%">断电</td>
          <td width="60%">16：00</td>
        </tr>
        <tr>
          <td width="40%">展商撤展</td>
          <td width="60%">16：00－22：00</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
     saveBtnStatue:false,  //保存铵钮状态
      demoExcel:'./CAC2024整合营销手册.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less" scoped>
  .Timetitle{
    font-size: 18px;
    margin-bottom: 40px;
  }
  .Tabletitle{
    font-size: 16px;
    margin-top: 30px;
  }
  .Timetable{
    width: 70%;
    display: inline-block;
    border-collapse: collapse;
    box-sizing:border-box;
  }
  .Timetable tr{
    width: 100%;
    display: inline-block;
  }
  .Timetable tr td{
    display: inline-block;
    border:1px solid rgb(178, 43, 101);
    height: 30px;
    line-height: 30px;
    text-align: center;
    box-sizing:border-box;
  }
</style>

